module.exports = __webpack_public_path__ + "static/media/ios-wallet.1e51b0c1.svg";